import { API_ROUTE } from "../../../utils/constants.js";
import { baseApi } from "../baseApi.js";
import { getToken } from "../localStorageService.js";

export const billingApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addbilling: builder.mutation({
      query: (user) => {
        return {
          url: API_ROUTE.addBilling,
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getbillings: builder.query({
      query: ({ search, limit, page }) => {
        return {
          url: `${API_ROUTE.getBillings}?search=${search}&limit=${limit}&page=${page}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
    updatebilling: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.updateBilling}/${user.id}`,
          method: "PATCH",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: getToken(),
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    deletebilling: builder.mutation({
      query: (user) => {
        return {
          url: `${API_ROUTE.deleteBilling}/${user.id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getExportBillsCSV: builder.query({
      query: () => {
        return {
          url: API_ROUTE.export_Billings,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
  }),
});

export const {
  useAddbillingMutation,
  useGetbillingsQuery,
  useUpdatebillingMutation,
  useDeletebillingMutation,
  useGetExportBillsCSVQuery,
} = billingApi;
